import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from '@avanta/shared/constants/common';
import { type Psychologist } from '@avanta/shared/types/psychologists';
import { AppointmentService } from '../services/appointments';

export const useFetchSearchPsychologist = ({
  name,
  insurance = false,
  contractId,
  patientId,
}: {
  name: string;
  insurance?: boolean;
  contractId?: string;
  patientId?: string;
}): UseQueryResult<Psychologist[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_PSYCHOLOGISTS_BY_NAME, name, insurance, contractId, patientId],
    queryFn: () =>
      AppointmentService.getPsychologistsByName({ name, insurance, contractId, patientId }),
    select: response => response.data,
  });
